"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Option = /** @class */ (function () {
    function Option() {
    }
    Option.of = function (value) {
        return value == null ? new None() : new Some(value);
    };
    Option['fantasy-land/of'] = function (value) {
        return new Some(value);
    };
    Option['fantasy-land/empty'] = function () {
        return new None();
    };
    Option['fantasy-land/zero'] = function () {
        return new None();
    };
    return Option;
}());
exports.Option = Option;
var None = /** @class */ (function (_super) {
    __extends(None, _super);
    function None() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    None.prototype.flatMap = function (_f) {
        return new None();
    };
    None.prototype.getOrElse = function (def) {
        return def;
    };
    None.prototype.isEmpty = function () {
        return true;
    };
    None.prototype.map = function (_f) {
        return new None();
    };
    None.prototype.nonEmpty = function () { return false; };
    None.prototype.orElse = function (alternative) {
        if (alternative.nonEmpty()) {
            return alternative;
        }
        return this;
    };
    None.prototype.toString = function () {
        return 'None';
    };
    // fantasyland
    None.prototype['fantasy-land/ap'] = function (_a) {
        return this;
    };
    None.prototype['fantasy-land/chain'] = function () {
        return this;
    };
    None.prototype['fantasy-land/map'] = function (_f) {
        return new None();
    };
    None['fantasy-land/of'] = function () {
        return new None();
    };
    return None;
}(Option));
exports.None = None;
var Some = /** @class */ (function (_super) {
    __extends(Some, _super);
    function Some(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    Some.prototype.flatMap = function (f) {
        return f(this.value);
    };
    Some.prototype.get = function () {
        return this.value;
    };
    Some.prototype.getOrElse = function (def) {
        return (this.value == null ||
            (typeof this.value === 'number' && isNaN(this.value))) ? def : this.value;
    };
    Some.prototype.isEmpty = function () {
        return false;
    };
    Some.prototype.map = function (f) {
        return new Some(f(this.value));
    };
    Some.prototype.nonEmpty = function () {
        return true;
    };
    Some.prototype.orElse = function (_alternative) {
        return this;
    };
    Some.prototype.toString = function () {
        return "Some(" + this.value + ")";
    };
    // fantasyland
    Some.prototype['fantasy-land/ap'] = function (a) {
        return a.flatMap(this.map.bind(this));
    };
    Some.prototype['fantasy-land/chain'] = function (f) {
        return f(this.value);
    };
    Some.prototype['fantasy-land/map'] = function (f) {
        return this.map(f);
    };
    Some['fantasy-land/of'] = function (value) {
        return new Some(value);
    };
    return Some;
}(Option));
exports.Some = Some;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/tsoption/index.js
// module id = 205
// module chunks = 0